import { Link } from "react-router-dom";
import type { ProponenteAdminSummary } from "../../../services/adminService";

export default function CadastrosPendentesPanel({
  proponentes,
}: {
  proponentes: ProponenteAdminSummary[];
}) {
  const todosPendentes = proponentes.filter((p) => p.documentos_pendentes);
  const pendentes = todosPendentes.slice(0, 3);

  return (
    <div className="bg-white border border-gray-200">
      <div className="px-6 py-4 border-b border-gray-200 flex items-center justify-between">
        <h2 className="text-base font-semibold text-gray-900">
          Cadastros Pendentes
        </h2>
        <span className="bg-orange-100 text-orange-700 px-2 py-1 text-xs font-medium rounded">
          {todosPendentes.length}
        </span>
      </div>
      {/* Container com altura fixa */}
      <div className="min-h-[400px] divide-y divide-gray-100">
        {pendentes.map((c) => (
          <div key={c.id} className="p-4 hover:bg-gray-50">
            <div className="flex items-start justify-between mb-2">
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-gray-900 truncate">
                  {c.nome_completo}
                </h3>
                <p className="text-xs text-gray-500 mt-0.5">{c.email}</p>
              </div>
            </div>
            <div className="flex items-center justify-between text-xs text-gray-600 mb-3">
              <span>Documento pendente</span>
              <span>—</span>
            </div>
            <Link
              to={`/admin/proponentes/${c.id}`}
              className="w-full block text-center bg-blue-600 hover:bg-blue-700 text-white text-sm py-2 rounded"
            >
              Analisar Cadastro
            </Link>
          </div>
        ))}
        {pendentes.length === 0 && (
          <div className="p-4 text-sm text-gray-500 text-center">
            Nenhum cadastro pendente
          </div>
        )}
      </div>

      {todosPendentes.length > 3 && (
        <div className="px-6 py-3 border-t border-gray-200 text-center">
          <Link
            to="/admin/proponentes?status=pendente"
            className="text-sm text-blue-600 hover:text-blue-700 font-medium hover:underline transition-colors"
          >
            + {todosPendentes.length - 3} cadastros não exibidos. Ver todos
          </Link>
        </div>
      )}
    </div>
  );
}
